"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchLOAStatus = fetchLOAStatus;
exports.fetchLOAContent = fetchLOAContent;
exports.fetchTermsStatus = fetchTermsStatus;
exports.fetchTermsContent = fetchTermsContent;
exports.fetchSharedInfoContent = fetchSharedInfoContent;
exports.updateTerms = updateTerms;
exports.toggleTaCModal = toggleTaCModal;
exports.launchTaCModal = launchTaCModal;
exports.updateCurrentlyAccepted = updateCurrentlyAccepted;
exports.default = terms;
exports.initialState = exports.LOA_CONTENT_FAILED = exports.LOA_CONTENT_FETCHED = exports.LOA_CONTENT_FETCHING = exports.LOA_STATUS_FAILED = exports.LOA_STATUS_FETCHED = exports.LOA_STATUS_FETCHING = exports.SHARED_INFO_FETCHED = exports.SHARED_INFO_FETCHING = exports.TERMS_UPDATED = exports.TERMS_UPDATING = exports.TERMS_STATUS_FETCHED = exports.TERMS_STATUS_FETCHING = exports.UPDATE_CURRENTLY_ACCEPTED_STATUS = exports.UPDATE_PREVIOUSLY_ACCEPTED_STATUS = exports.TERMS_FETCHED = exports.TERMS_FETCHING = exports.TOGGLE_TAC_MODAL = void 0;

var _merge4 = _interopRequireDefault(require("lodash/merge"));

var _has2 = _interopRequireDefault(require("lodash/has"));

var _get2 = _interopRequireDefault(require("lodash/get"));

var listingActions = _interopRequireWildcard(require("../listing/listingModule"));

var _utils = require("../utils");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var APIEndpoint = (0, _utils.getAPIEndpoint)();
var TOGGLE_TAC_MODAL = '@@termsModule/TOGGLE_TAC_MODAL';
exports.TOGGLE_TAC_MODAL = TOGGLE_TAC_MODAL;
var TERMS_FETCHING = '@@termsModule/TERMS_FETCHING';
exports.TERMS_FETCHING = TERMS_FETCHING;
var TERMS_FETCHED = '@@termsModule/TERMS_FETCHED';
exports.TERMS_FETCHED = TERMS_FETCHED;
var UPDATE_PREVIOUSLY_ACCEPTED_STATUS = '@@termsModule/UPDATE_PREVIOUSLY_ACCEPTED_STATUS';
exports.UPDATE_PREVIOUSLY_ACCEPTED_STATUS = UPDATE_PREVIOUSLY_ACCEPTED_STATUS;
var UPDATE_CURRENTLY_ACCEPTED_STATUS = '@@termsModule/UPDATE_CURRENTLY_ACCEPTED_STATUS';
exports.UPDATE_CURRENTLY_ACCEPTED_STATUS = UPDATE_CURRENTLY_ACCEPTED_STATUS;
var TERMS_STATUS_FETCHING = '@@termsModule/TERMS_STATUS_FETCHING';
exports.TERMS_STATUS_FETCHING = TERMS_STATUS_FETCHING;
var TERMS_STATUS_FETCHED = '@@termsModule/TERMS_STATUS_FETCHED';
exports.TERMS_STATUS_FETCHED = TERMS_STATUS_FETCHED;
var TERMS_UPDATING = '@@termsModule/TERMS_UPDATING';
exports.TERMS_UPDATING = TERMS_UPDATING;
var TERMS_UPDATED = '@@termsModule/TERMS_UPDATED';
exports.TERMS_UPDATED = TERMS_UPDATED;
var SHARED_INFO_FETCHING = '@@termsModule/SHARED_INFO_FETCHING';
exports.SHARED_INFO_FETCHING = SHARED_INFO_FETCHING;
var SHARED_INFO_FETCHED = '@@termsModule/SHARED_INFO_FETCHED';
exports.SHARED_INFO_FETCHED = SHARED_INFO_FETCHED;
var LOA_STATUS_FETCHING = '@@termsModule/LOA_STATUS_FETCHING';
exports.LOA_STATUS_FETCHING = LOA_STATUS_FETCHING;
var LOA_STATUS_FETCHED = '@@termsModule/LOA_STATUS_FETCHED';
exports.LOA_STATUS_FETCHED = LOA_STATUS_FETCHED;
var LOA_STATUS_FAILED = '@@termsModule/LOA_STATUS_FAILED';
exports.LOA_STATUS_FAILED = LOA_STATUS_FAILED;
var LOA_CONTENT_FETCHING = '@@termsModule/LOA_CONTENT_FETCHING';
exports.LOA_CONTENT_FETCHING = LOA_CONTENT_FETCHING;
var LOA_CONTENT_FETCHED = '@@termsModule/LOA_CONTENT_FETCHED';
exports.LOA_CONTENT_FETCHED = LOA_CONTENT_FETCHED;
var LOA_CONTENT_FAILED = '@@termsModule/LOA_CONTENT_FAILED';
exports.LOA_CONTENT_FAILED = LOA_CONTENT_FAILED;

function fetchLOAStatus(userId) {
  return function asyncFetchLOAStatus(dispatch, getState) {
    var stateId, _getState, _getState$JWT, _getState$JWT$token, token, options, response, status;

    return regeneratorRuntime.async(function asyncFetchLOAStatus$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            // there are two places to get userId, we should consolidate.
            // one comes from us encoding what we have from session, the other from an api call
            stateId = (0, _get2.default)(getState(), 'userProfile.profile.UserID', false);

            if (!(!userId && !stateId)) {
              _context.next = 3;
              break;
            }

            return _context.abrupt("return", Promise.reject(new Error('could not find a userId in fetchLOAStatus call or state')));

          case 3:
            dispatch({
              type: LOA_STATUS_FETCHING
            });
            _getState = getState(), _getState$JWT = _getState.JWT;
            _getState$JWT = _getState$JWT === void 0 ? {} : _getState$JWT;
            _getState$JWT$token = _getState$JWT.token, token = _getState$JWT$token === void 0 ? '' : _getState$JWT$token;
            options = {
              method: 'GET',
              headers: {
                'Content-Type': 'application/json'
              }
            };
            if (token) options.headers.Authorization = "Bearer ".concat(token);
            _context.prev = 9;
            _context.next = 12;
            return regeneratorRuntime.awrap(fetch("".concat(APIEndpoint, "v3/terms/loa/status"), options));

          case 12:
            response = _context.sent;
            _context.next = 15;
            return regeneratorRuntime.awrap(response.json());

          case 15:
            status = _context.sent;
            dispatch({
              type: LOA_STATUS_FETCHED,
              term: "".concat(status.type, "Status"),
              status: status.accepted
            });
            return _context.abrupt("return", status);

          case 20:
            _context.prev = 20;
            _context.t0 = _context["catch"](9);
            dispatch({
              type: LOA_STATUS_FAILED,
              message: 'request failed'
            });
            return _context.abrupt("return", Promise.reject('request failed'));

          case 24:
          case "end":
            return _context.stop();
        }
      }
    }, null, null, [[9, 20]]);
  };
}

function fetchLOAContent() {
  return function asyncFetchLOAContent(dispatch, getState) {
    var state, _state$userPrefs$loca, lang, options, response, html;

    return regeneratorRuntime.async(function asyncFetchLOAContent$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            state = getState();

            if (!((0, _has2.default)(state, 'terms.loa.content.html') && state.terms.loa.content.html)) {
              _context2.next = 3;
              break;
            }

            return _context2.abrupt("return", Promise.resolve((0, _get2.default)(state, 'terms.loa.content.html')));

          case 3:
            _state$userPrefs$loca = state.userPrefs.localeData.lang, lang = _state$userPrefs$loca === void 0 ? 'en-us' : _state$userPrefs$loca;
            options = {
              method: 'GET'
            };
            dispatch({
              type: LOA_CONTENT_FETCHING
            });
            _context2.prev = 6;
            _context2.next = 9;
            return regeneratorRuntime.awrap(fetch("".concat(APIEndpoint, "v3/terms/loa?lang=").concat(lang), options));

          case 9:
            response = _context2.sent;
            _context2.next = 12;
            return regeneratorRuntime.awrap(response.text());

          case 12:
            html = _context2.sent;
            dispatch({
              type: LOA_CONTENT_FETCHED,
              html: html
            });
            _context2.next = 20;
            break;

          case 16:
            _context2.prev = 16;
            _context2.t0 = _context2["catch"](6);
            dispatch({
              type: LOA_CONTENT_FAILED,
              message: _context2.t0.message
            });
            return _context2.abrupt("return", Promise.reject('request failed'));

          case 20:
          case "end":
            return _context2.stop();
        }
      }
    }, null, null, [[6, 16]]);
  };
}

function fetchTermsStatus() {
  return function asyncFetchTermsStatus(dispatch, getState) {
    var _getState2, _getState2$JWT, _getState2$JWT$token, token, options, termsStatusReponse, termsJSON, pass;

    return regeneratorRuntime.async(function asyncFetchTermsStatus$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _getState2 = getState(), _getState2$JWT = _getState2.JWT;
            _getState2$JWT = _getState2$JWT === void 0 ? {} : _getState2$JWT;
            _getState2$JWT$token = _getState2$JWT.token, token = _getState2$JWT$token === void 0 ? '' : _getState2$JWT$token;
            dispatch({
              type: TERMS_STATUS_FETCHING
            });
            options = {
              method: 'GET',
              headers: {
                'Content-Type': 'application/json'
              }
            };
            if (token) options.headers.Authorization = "Bearer ".concat(token); // Get term status, update their status in the store. If either
            // has not abeen accepted, return false, else return true

            _context3.prev = 6;
            _context3.next = 9;
            return regeneratorRuntime.awrap(fetch("".concat(APIEndpoint, "v3/terms/appcenter/status"), options));

          case 9:
            termsStatusReponse = _context3.sent;
            _context3.next = 12;
            return regeneratorRuntime.awrap(termsStatusReponse.json());

          case 12:
            termsJSON = _context3.sent;
            pass = true;

            if (!termsJSON.accepted) {
              pass = termsJSON.accepted;
            }

            dispatch({
              type: UPDATE_PREVIOUSLY_ACCEPTED_STATUS,
              term: "".concat(termsJSON.type, "Status"),
              status: termsJSON.accepted
            });
            dispatch({
              type: TERMS_STATUS_FETCHED
            });
            return _context3.abrupt("return", pass);

          case 20:
            _context3.prev = 20;
            _context3.t0 = _context3["catch"](6);
            throw _context3.t0;

          case 23:
          case "end":
            return _context3.stop();
        }
      }
    }, null, null, [[6, 20]]);
  };
}

function fetchTermsContent() {
  return function asyncFetchTermsContent(dispatch, getState) {
    var _getState3, appcenterTerms, options, response, data;

    return regeneratorRuntime.async(function asyncFetchTermsContent$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _getState3 = getState(), appcenterTerms = _getState3.terms.appcenterTerms;

            if (!appcenterTerms) {
              _context4.next = 3;
              break;
            }

            return _context4.abrupt("return");

          case 3:
            dispatch({
              type: TERMS_FETCHING
            });
            options = {
              method: 'GET',
              headers: {}
            };
            _context4.next = 7;
            return regeneratorRuntime.awrap(fetch("".concat(APIEndpoint, "v3/terms/"), options));

          case 7:
            response = _context4.sent;
            _context4.next = 10;
            return regeneratorRuntime.awrap(response.json());

          case 10:
            data = _context4.sent;
            dispatch({
              type: TERMS_FETCHED,
              terms: data
            });

          case 12:
          case "end":
            return _context4.stop();
        }
      }
    });
  };
}

function fetchSharedInfoContent(listingId, v1ListingId) {
  return function asyncFetchSharedInfoContent(dispatch, getState) {
    var _getState4, _getState4$userPrefs$, lang, ID, options, response, json, data;

    return regeneratorRuntime.async(function asyncFetchSharedInfoContent$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _getState4 = getState(), _getState4$userPrefs$ = _getState4.userPrefs.localeData.lang, lang = _getState4$userPrefs$ === void 0 ? 'en-us' : _getState4$userPrefs$;
            dispatch({
              type: SHARED_INFO_FETCHING
            });

            if ((0, _has2.default)(getState(), "listing[".concat(listingId, "].data.core"))) {
              ID = listingId;
            } else {
              ID = v1ListingId;
            }

            options = {
              method: 'GET',
              headers: {}
            };
            _context5.prev = 4;
            _context5.next = 7;
            return regeneratorRuntime.awrap(fetch("".concat(APIEndpoint, "v3/listings/").concat(ID, "/scopes?lang=").concat(lang), options));

          case 7:
            response = _context5.sent;
            _context5.next = 10;
            return regeneratorRuntime.awrap(response.json());

          case 10:
            json = _context5.sent;
            // TODO: what is this?
            data = json.map(function (i) {
              return i.description;
            });
            return _context5.abrupt("return", dispatch({
              type: SHARED_INFO_FETCHED,
              data: data
            }));

          case 15:
            _context5.prev = 15;
            _context5.t0 = _context5["catch"](4);
            return _context5.abrupt("return", Promise.reject(_context5.t0));

          case 18:
          case "end":
            return _context5.stop();
        }
      }
    }, null, null, [[4, 15]]);
  };
}

function updateTerms(userId) {
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'appcenter';
  return function asyncUpdateTerms(dispatch, getState) {
    var _getState5, _getState5$JWT, _getState5$JWT$token, token, options;

    return regeneratorRuntime.async(function asyncUpdateTerms$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            _getState5 = getState(), _getState5$JWT = _getState5.JWT;
            _getState5$JWT = _getState5$JWT === void 0 ? {} : _getState5$JWT;
            _getState5$JWT$token = _getState5$JWT.token, token = _getState5$JWT$token === void 0 ? '' : _getState5$JWT$token;
            dispatch({
              type: TERMS_UPDATING
            });
            options = {
              method: 'PUT',
              headers: {
                'Content-Type': 'application/json'
              }
            };
            if (token) options.headers.Authorization = "Bearer ".concat(token);
            _context6.prev = 6;
            _context6.next = 9;
            return regeneratorRuntime.awrap(fetch("".concat(APIEndpoint, "v3/terms/").concat(type, "/status"), options));

          case 9:
            return _context6.abrupt("return", _context6.sent);

          case 12:
            _context6.prev = 12;
            _context6.t0 = _context6["catch"](6);
            return _context6.abrupt("return", Promise.reject(_context6.t0));

          case 15:
          case "end":
            return _context6.stop();
        }
      }
    }, null, null, [[6, 12]]);
  };
}

function toggleTaCModal(tAndCLinkClicked) {
  return function (dispatch) {
    return dispatch({
      type: TOGGLE_TAC_MODAL,
      tAndCLinkClicked: tAndCLinkClicked
    });
  };
}

function launchTaCModal(_ref) {
  var tAndCLinkClicked = _ref.tAndCLinkClicked,
      _ref$flow = _ref.flow,
      flow = _ref$flow === void 0 ? '' : _ref$flow,
      listingId = _ref.listingId,
      v1ListingId = _ref.v1ListingId,
      _ref$needAnAccountCli = _ref.needAnAccountClicked,
      needAnAccountClicked = _ref$needAnAccountCli === void 0 ? {
    needAnAccountClicked: false
  } : _ref$needAnAccountCli;
  return function (dispatch, getState) {
    var _getState6 = getState(),
        _getState6$terms = _getState6.terms,
        appcenterTerms = _getState6$terms.appcenterTerms,
        appcenterStatus = _getState6$terms.appcenterStatus;

    if (needAnAccountClicked) {
      dispatch(listingActions.toggleNeedAnAccountClicked(true));
    }

    if (tAndCLinkClicked && !appcenterTerms) {
      dispatch(toggleTaCModal(tAndCLinkClicked));
      dispatch(fetchTermsContent());
      dispatch(fetchSharedInfoContent(listingId, v1ListingId));
      dispatch(fetchLOAContent);
    } else {
      var ACTermsOK = appcenterStatus.previouslyAccepted || appcenterStatus.currentlyAccepted;

      if (flow === 'WEBFLOW' && ACTermsOK) {
        dispatch(listingActions.connectListing(listingId, v1ListingId));
        return;
      }

      dispatch(toggleTaCModal());
      dispatch(fetchTermsContent());
      dispatch(fetchSharedInfoContent(listingId, v1ListingId));
    }
  };
}

function updateCurrentlyAccepted(field, value) {
  return function (dispatch) {
    return dispatch({
      type: UPDATE_CURRENTLY_ACCEPTED_STATUS,
      field: field,
      value: value
    });
  };
}

var initialState = {
  isTaCModalOpen: false,
  tAndCLinkClicked: false,
  appcenterStatus: {
    previouslyAccepted: false,
    currentlyAccepted: false
  },
  loa: {
    status: {
      previouslyAccepted: false,
      currentlyAccepted: false
    },
    content: {
      html: ''
    }
  },
  ereceiptStatus: {
    previouslyAccepted: false,
    currentlyAccepted: false
  },
  sharedInfoStatus: {
    currentlyAccepted: false
  },
  sharedInfo: [],
  content: [{
    type: 'appcenter',
    content: ''
  }]
}; // this reducer handles everything off of rootState.terms

exports.initialState = initialState;

function terms() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case TOGGLE_TAC_MODAL:
      return (0, _merge4.default)({}, state, {
        isTaCModalOpen: !state.isTaCModalOpen,
        tAndCLinkClicked: action.tAndCLinkClicked
      });

    case UPDATE_PREVIOUSLY_ACCEPTED_STATUS:
      return (0, _merge4.default)({}, state, _defineProperty({}, action.term, {
        previouslyAccepted: action.status
      }));

    case UPDATE_CURRENTLY_ACCEPTED_STATUS:
      // loa has a different (newer, better) schema than appcenter and ereceipt
      if (action.field === 'loaStatus') {
        return (0, _merge4.default)({}, state, {
          loa: {
            status: {
              currentlyAccepted: action.value
            }
          }
        });
      }

      return (0, _merge4.default)({}, state, _defineProperty({}, action.field, {
        currentlyAccepted: action.value
      }));

    case TERMS_FETCHED:
      return _objectSpread({}, state, {
        content: action.terms
      });

    case SHARED_INFO_FETCHED:
      return _objectSpread({}, state, {
        sharedInfo: action.data
      });

    case LOA_STATUS_FETCHING:
      return _objectSpread({}, state, {
        loa: _objectSpread({}, state.loa, {
          status: {
            readyState: 'FETCHING'
          }
        })
      });

    case LOA_STATUS_FETCHED:
      return _objectSpread({}, state, {
        loa: _objectSpread({}, state.loa, {
          status: {
            readyState: 'FETCHED',
            previouslyAccepted: action.status,
            currentlyAccepted: action.status
          }
        })
      });

    case LOA_STATUS_FAILED:
      return _objectSpread({}, state, {
        loa: _objectSpread({}, state.loa, {
          status: {
            readyState: 'FAILED',
            message: action.message
          }
        })
      });

    case LOA_CONTENT_FETCHING:
      return _objectSpread({}, state, {
        loa: _objectSpread({}, state.loa, {
          content: {
            readyState: 'FETCHING'
          }
        })
      });

    case LOA_CONTENT_FETCHED:
      return _objectSpread({}, state, {
        loa: _objectSpread({}, state.loa, {
          content: {
            readyState: 'FETCHED',
            html: action.html
          }
        })
      });

    case LOA_CONTENT_FAILED:
      return _objectSpread({}, state, {
        loa: _objectSpread({}, state.loa, {
          content: {
            readyState: 'FAILED',
            message: action.message
          }
        })
      });

    default:
      return state;
  }
}


//////////////////
// WEBPACK FOOTER
// ./lib/terms/termsModule.js
// module id = 14
// module chunks = 0